<div class="header-container">
    <div class="header-area">
        <h1 translate>
            home.title
        </h1>
        <p translate>
            home.subtitle
        </p>
    </div>
</div>

<div class="content-search-container">
    <mat-form-field class="chip-list-area" (keydown)="onKeydown($event)">
        <mat-chip-list #chipList aria-label="search">
            <mat-chip
                *ngFor="let tag of Tags"
                [selectable]="selectable"
                [removable]="removable"
                (removed)="remove(tag)">
                {{ tag | translate }}
                <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
            </mat-chip>
            <input 
                placeholder="{{ placeholder | translate }}"
                #tagInput
                [formControl]="tagCtrl"
                [matAutocomplete]="auto"
                [matChipInputFor]="chipList"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                (matChipInputTokenEnd)="add($event)">
        </mat-chip-list>
        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
            <mat-option *ngFor="let tag of filteredTag | async" [value]="tag">
                {{ tag | translate }}
            </mat-option>
        </mat-autocomplete>
    </mat-form-field>
    <button (click)="onClick()"
             mat-icon-button 
             color="accent"
             aria-label="search button">
        <mat-icon>search</mat-icon>
    </button>
</div>

<div class="content-main-container">
    <div class="aboutus_area">
        <div class="aboutus_message">
            <span translate>aboutus.explanation01</span>
            <br>
            <span translate>aboutus.explanation02</span>
        </div>
        <button routerLink="/aboutus"
                mat-flat-button 
                color="accent">
                <span translate>navigation.aboutus</span>
        </button>
    </div>
    <hr class="splitter">
    <div class="menu_area">
        <div fxLayout="row wrap" fxLayoutAlign="center space-around">
            <div *ngFor="let tile of tiles">
                <mat-card                     
                    class="category-card"
                    [routerLink]="tile.link"
                    [ngStyle]="cardStyle(tile.color)"
                    >
                    <mat-card-title 
                        [style.color]="tile.color"
                        translate>
                        {{tile.title}}
                    </mat-card-title>
                    <mat-card-content translate>
                        {{tile.explanation}}
                    </mat-card-content>
                    <img mat-card-image [src]="tile.image">
                </mat-card>
            </div>
        </div>
    </div>
    <hr class="splitter">
    <div class="links">
        <h2 translate>home.link</h2>
        <div fxLayout="row wrap" fxLayoutAlign="center space-around">
            <ng-container *ngFor="let l of links">
                <div class="link_info">
                    <a [href]="l.url" target="_blank" rel="noopener noreferrer">
                        <div class="link_img" style="background-image: url('{{l.image}}')"></div>
                    </a>
                    <div class="link_detail">
                        <span style="font-size: large;" translate>{{ l.title }}</span>
                        <br>
                        <span translate>{{ l.content }}</span>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</div>